/**
 * 404 — dark navy, friendly copy, link home. Wired as catch-all in App.js.
 */
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
         style={{ background: "#0A0F1E", color: "#F7F8FC" }}
         data-testid="not-found-page">
      <p className="font-mono text-[10rem] leading-none text-slate-700 select-none">404</p>
      <p className="text-lg mt-4 font-medium">This page doesn't exist</p>
      <p className="text-sm text-slate-400 mt-2 max-w-md">
        The URL you followed might be broken, or the page may have moved.
      </p>
      <Link to="/" data-testid="not-found-back-link"
            className="mt-8 inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium bg-sky-500 hover:bg-sky-400 text-white transition-colors">
        <ArrowLeft className="w-4 h-4" /> Back to Ragnes
      </Link>
    </div>
  );
}
